import Header from "./Header";
import Loader from "./Loader";
import { useEffect, useState } from "react";
import Footer from "./footer";
import "../CSS/about.css"; // Link your CSS file here
import { FaFacebook, FaLinkedin, FaTwitter, FaInstagram } from "react-icons/fa";

const AboutUs = () => {
    const [isLoader, setIsLoader] = useState(true);

    useEffect(() => {
        setTimeout(() => setIsLoader(false), 2900);
    }, []);

    return (
        <div>
            <Header />
            {isLoader ? (
                <Loader />
            ) : (
                <div className="">
                    <div>
                        <div className="content-about">
                            <h1 className="h1-about">
                                ABOUT US
                                <br />
                                <img src="https://image.ibb.co/nk616F/Layer_1_copy_21.png" width="47" height="11" align="center" />
                            </h1>
                            <article className="article-about">
                                <div className="aboutus-container">
                                    <h2>Fast Time-to-Value</h2>
                                    <p>
                                        Offering an iterative approach for long-term transformational initiatives, we manage to start providing tangible business value as early as possible. Even first small steps towards a more consistent and balanced IT environment optimize operational expenses, like high maintenance costs for obsolete IT assets.
                                    </p>

                                    <h2>Fair Pricing</h2>
                                    <p>
                                        We apply a pricing model depending on the nature of the consulting service we render.
                                    </p>
                                    <ul>
                                        <li>Fixed Price – for time-bound services with clearly defined deliverables: a feasibility study, solution prototyping, market research.</li>
                                        <li>Time & Material – for long-term involvements when the service scope can’t be estimated accurately at the start: an operational review of an IT department, an IT audit, modernization of a bunch of business apps.</li>
                                    </ul>

                                    <h2>Value-Driven IT Strategies</h2>
                                    <p>
                                        The landscape of IT technologies and innovations is vast and growing. We help companies navigate it and make smart IT investments into areas with real profit potential. When planning an IT strategy, we communicate explicitly the value of changes, typically centered around cost reduction, workflow automation, expansion into new revenue channels, or service quality improvement.
                                    </p>
                                </div>
                            </article>

                            <div className="social_icons">
                                <a target="_blank" href="https://m.facebook.com/people/Infinity-Tech-Resources/100064283701151/">
                                    <div className="square fa-facebook">
                                        <div className="icons">
                                            <FaFacebook size="1.5em" />
                                        </div>
                                    </div>
                                </a>

                                <a target="_blank" href="https://in.linkedin.com/in/samuel-patole-011348228?trk=public_profile_samename-profile">
                                    <div className="square fa-linkedIn">
                                        <div className="icons">
                                            <FaLinkedin size="1.5em" />
                                        </div>
                                    </div>
                                </a>

                                <a target="_blank" href="https://twitter.com">
                                    <div className="square fa-twitter">
                                        <div className="icons">
                                            <FaTwitter size="1.5em" />
                                        </div>
                                    </div>
                                </a>

                                <a target="_blank" href="https://www.instagram.com/infinity.resources?igsh=MXhwNHAyYW15NnR3bQ==">
                                    <div className="square fa-instagram">
                                        <div className="icons">
                                            <FaInstagram size="1.5em" />
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <Footer />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AboutUs;
